import {
    FEATURE_FLAGS_DATA,
} from "../../constants/ActionTypes";

const INIT_STATE = {
    featureFlags: [],
};

const featureFlagReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FEATURE_FLAGS_DATA: {
            return {
                ...state,
                featureFlags: action.payload,
            }
        }
        default:
            return state;
    }
}

export default featureFlagReducer;
